/**
 * What Free and Pro include, in the words of the app's feature registry
 * (src/config/features.js at the repository root: training_programs,
 * custom_workouts, pro_analytics, crews). Prices are NOT here - they come
 * from config/site.js. src/__tests__/facts.test.js holds the Pro list to the
 * registry's Pro-tier features.
 */
export const FREE = [
  'The Foundations program',
  'Every timer, and the Apple Watch app',
  'Workout logging, progress, records and your full history',
  'Joining crews',
];

export const PRO = [
  'Everything in Free',
  'Every program, including Full Body Strength and Kettlebell Conditioning',
  'Custom workouts: build your own, run them on your phone or your wrist',
  'Training analytics: each exercise’s trend, balance by movement, planned against done',
  'Creating crews',
];
